export const skillCategories = [
  {
    name: 'Programming',
    items: ['JavaScript', 'TypeScript', 'Java', 'Swift', 'Kotlin', 'C#', 'Python', 'Ruby', 'SQL'],
  },
  {
    name: 'Frontend',
    items: ['React', 'React Native', 'Expo', 'Next.js', 'Tailwind', 'Apollo / GraphQL', 'Three.js'],
  },
  {
    name: 'Backend',
    items: ['Spring Boot', 'Ruby on Rails', 'Nest.js', 'Node.js', 'REST', 'Firebase', 'MySQL'],
  },
  {
    name: 'Infrastructure & Tools',
    items: ['AWS', 'GCP', 'Shopify', 'Jenkins', 'Git', 'Linux / Shell', 'BLE / Arduino', 'Mistral AI'],
  },
  {
    name: 'Spoken Languages',
    items: ['French (native)', 'English (TOEIC 950)', 'Spanish', 'Mandarin (basics)'],
  },
];
